import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject, Subscription } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService implements OnDestroy {

  private _lang$ = new BehaviorSubject<string>('');
  get lang(): string {
    return this._lang$.value;
  }
  lang$ = this._lang$.asObservable();

  private subscription = new Subscription();

  constructor(
    private activatedRoute: ActivatedRoute,
    private translationService: TranslocoService,
  ) {
    this.languageHandler();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private languageHandler() {
    this.subscription.add(
      this.activatedRoute.queryParams
        .pipe(
          pluck('lang')
        ).subscribe((lang: string) => {
          if (['nl', 'fr', 'de'].includes(lang)) {
            this._lang$.next(lang);
          } else {
            this._lang$.next(this.translationService.getDefaultLang());
          }
        })
    );
  }

}
